<template>
  <div class="location-selector">
    <b-dropdown
      v-if="selectedLocationComputed"
      class="w-100"
      toggle-class="text-decoration-none hover-pointer px-2"
      no-caret
      variant="link"
    >
      <template v-slot:button-content>
        <div
          class="d-flex align-items-center justify-content-start color-custom-dark-grey"
        >
          <div class="d-flex flex-column text-left">
            <div
              class="d-flex align-items-center justify-content-between"
              style="font-size:14px;"
            >
              <strong>
                {{ selectedLocationComputed.name }}
              </strong>
            </div>
            <span v-if="selectedLocation" style="font-size: 11px">
              <span> {{ formatTimeOnly(currentLocationTime) }} </span>
              <span>{{ selectedLocationComputed.timeZoneDisplayName }}</span>
            </span>
          </div>
          <i class="fas fa-sort ml-3"></i>
        </div>
      </template>
      <b-dropdown-form
        style="width: 281px; max-height: 250px; overflow-y: auto;"
      >
        <div
          v-for="(location, locationIndex) in locations"
          :key="location.id"
          class="d-flex justify-content-between align-items-center border-color-light-gray"
          :style="
            'height:54px; margin-left: 10px; margin-right: 10px;' +
              (locationIndex < locations.length - 1
                ? 'border-bottom: 2px solid;'
                : '')
          "
        >
          <div class="color-custom-dark-grey text-left">
            <div
              class="ml-2"
              style="
                margin-bottom: -8px; 
                max-width: 210px;
                overflow-x: hidden;
                white-space: nowrap;"
            >
              {{ location.name }}
            </div>
            <div class="ml-2">
              <i style="font-size: 10px;">
                {{ location.timeZoneDisplayName }}
              </i>
            </div>
          </div>
          <span
            v-if="selectedLocation != location.id"
            style="font-size: 13px;"
            class="hover-pointer text-primary"
            @click="setSelectedLocation(location.id)"
          >
            Select
          </span>
          <img v-else :src="require('../../assets/icons/check.png')" />
        </div>
      </b-dropdown-form>
    </b-dropdown>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";

export default {
  name: "LocationSelector",
  data() {
    return {
      currentLocationTime: null
    };
  },
  async mounted() {
    setInterval(() => {
      this.currentLocationTime = this.getCurrentAdjustedDateTime();
    }, 1000);
    await this.fetchLocations();
  },
  methods: {
    ...mapMutations("layout", ["setSelectedLocation"]),
    ...mapActions("client", ["fetchLocations"]),
    updateTimeNow() {
      this.currentLocationTime = this.getCurrentAdjustedDateTime();
    }
  },
  computed: {
    ...mapState("layout", {
      currentUser: state => state.currentUser,
      selectedLocation: state => state.selectedLocation,
      locations: state => state.locations
    }),
    ...mapState("client", {
      allLocations: state => state.locations
    }),
    ...mapGetters("layout", ["getCurrentAdjustedDateTime"]),
    locations() {
      let locations = [];
      if (this.currentUser) {
        if (this.currentUser.role.name == "Tech Staff") {
          locations = [...this.allLocations];
        } else {
          locations = [
            ...(this.currentUser.accessToLocations
              ? this.currentUser.accessToLocations
              : [])
          ];
        }
        if (locations.length > 1) {
          locations = [{ id: null, name: "All locations" }, ...locations];
        }
      }
      return locations;
    },
    selectedLocationComputed() {
      if (this.currentUser) {
        return this.locations.find(l => l.id == this.selectedLocation);
      }
      return null;
    }
  }
};
</script>

<style scoped>
.location-selector >>> .btn {
  border-radius: 8px;
  transition: background-color 300ms ease;
}

.location-selector >>> .btn:hover {
  background-color: #f5f8fc !important;
}
.location-selector >>> .btn {
  height: 65px;
  display: flex;
  align-items: center;
  border-radius: 0px;
  padding-left: 22px !important;
  padding-right: 22px !important;
}
</style>
